/**
 * HHMS MIS — single source of truth for the API origin.
 *
 * Resolution priority:
 *   1. REACT_APP_API_URL — explicit build-time override (any environment).
 *   2. Production build   — SAME ORIGIN ('' → root-relative /api/... URLs).
 *      The SPA is served by nginx, which reverse-proxies /api and /ws to the
 *      FastAPI backend on the internal docker network. No host/port is baked
 *      in, so TLS and CORS "just work" and the build is host-agnostic.
 *   3. Dev / LAN          — the backend dev server on :9000 of whatever host
 *      loaded the page, so phones/tablets reach the API by the same IP.
 *
 * `API_ORIGIN` never has a trailing slash. It is either '' (same origin) or a
 * scheme+host[:port] with no path. Callers append their own path, e.g.
 * `${API_ORIGIN}/api/v1/...`.
 */
const explicit = process.env.REACT_APP_API_URL;

export const API_ORIGIN = (
  explicit !== undefined && explicit !== null && explicit !== ''
    ? explicit
    : process.env.NODE_ENV === 'production'
      ? '' // served behind nginx TLS — same origin
      : typeof window !== 'undefined'
        ? `${window.location.protocol}//${window.location.hostname}:9000`
        : ''
).replace(/\/+$/, '');
